import cf from './cf';
import i1zv1_20211024 from './i1zv1_20211024';

export default class i1zv1a extends i1zv1_20211024 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
//    this.class = 'i1zv1a';
    global.t = this;
    this.d_viewDefs = {
      name: '直接予約',
      class: 'i1zv1a',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
